import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtLastConv } from "@/lib/format";
import { Handshake } from "lucide-react";

// Summary line: last partner update + open bank queries; expands to the audited partner activity list (internal only).
export function PartnerLine({ recordId }) {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get(`/cases/${recordId}/partner-activity`).then((r) => setD(r.data)).catch(() => {}); }, [recordId]);
  if (!d || (!d.last_update && !d.open_queries && d.activity.length === 0)) return null;
  return (
    <div className="rounded-2xl border border-[#38A2FF]/30 bg-[#38A2FF]/5 p-4" data-testid="summary-partner-line">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-xs font-medium text-[#1b6fb0] uppercase flex items-center gap-1.5" style={{ letterSpacing: "0.06em" }}><Handshake className="w-3.5 h-3.5" /> Partner</h3>
        <button onClick={() => setOpen((v) => !v)} className="text-[11px] text-[#1b6fb0] hover:underline" data-testid="summary-partner-activity-toggle">{open ? "Hide activity" : `Partner activity (${d.activity.length})`}</button>
      </div>
      <div className="text-xs text-[#333333] mt-1">
        {d.last_update ? <>Partner update: <b>{d.last_update.text}</b> <span className="text-[#6B7280]">· {d.last_update.spoc_name} · {fmtLastConv(d.last_update.created_at)}</span></> : <span className="text-[#6B7280]">No partner updates yet</span>}
        {d.open_queries > 0 && <span className="ml-2 px-2 py-0.5 rounded-full bg-[#CA1212]/10 text-[#CA1212] font-medium" data-testid="summary-open-queries">{d.open_queries} open bank {d.open_queries === 1 ? "query" : "queries"}</span>}
      </div>
      {open && (
        <div className="mt-2 space-y-0.5 max-h-56 overflow-auto" data-testid="summary-partner-activity">
          {d.activity.map((a, i) => <div key={i} className="text-[11px] text-[#6B7280]"><span className="text-[#333333]">{a.actor}</span> · {a.action.replace("partner_", "").replace(/_/g, " ")}{a.new_value ? ` · ${String(a.new_value).slice(0, 80)}` : ""} · {fmtLastConv(a.timestamp)}</div>)}
        </div>
      )}
    </div>
  );
}
